import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Brand from '../components/Brand';
import ConsentCheckboxes from '../components/ConsentCheckboxes';

function Signup({ onSignup }) {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [smsConsent, setSmsConsent] = useState(false);
  const [termsConsent, setTermsConsent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!name.trim() || !password.trim()) {
      setError('Please enter your name and password');
      return;
    }
    if (!email.trim() && !phone.trim()) {
      setError('Please enter either an email or a phone number');
      return;
    }

    navigate('/verify-otp', {
      state: {
        flow: 'signup',
        identifier: phone || email,
        method: phone ? 'phone' : 'email',
        userData: { name, email, phone, smsConsent, termsConsent },
      },
    });
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <Brand />
        <h1 className="auth-title">Create your account</h1>
        <p className="auth-subtitle">Start building your Bluprint today</p>

        {error && <div className="error-msg">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Full name</label>
            <input
              className="form-input"
              type="text"
              placeholder="Jordan Rivera"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Email address</label>
            <input
              className="form-input"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Phone number</label>
            <input
              className="form-input"
              type="tel"
              placeholder="+1 555 000 0000"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              className="form-input"
              type="password"
              placeholder="Create a password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <ConsentCheckboxes
            smsConsent={smsConsent}
            setSmsConsent={setSmsConsent}
            termsConsent={termsConsent}
            setTermsConsent={setTermsConsent}
          />

          <button type="submit" className="btn-primary">
            Create Account
          </button>
        </form>

        <div className="auth-links">
          Already have an account? <Link to="/login">Sign in</Link>
        </div>
      </div>
    </div>
  );
}

export default Signup;
